import * as Schema from "effect/Schema";
export const ContextMenuItemSchema = Schema.Struct({
    id: Schema.String,
    label: Schema.String,
    destructive: Schema.optionalKey(Schema.Boolean),
    disabled: Schema.optionalKey(Schema.Boolean),
    header: Schema.optionalKey(Schema.Boolean),
    icon: Schema.optionalKey(Schema.String),
    separator: Schema.optionalKey(Schema.Boolean),
    children: Schema.optionalKey(Schema.Array(Schema.suspend(() => ContextMenuItemSchema))),
});
export const DesktopUpdateStatusSchema = Schema.Literals([
    "disabled",
    "idle",
    "checking",
    "up-to-date",
    "available",
    "downloading",
    "downloaded",
    "error",
]);
export const DesktopRuntimeArchSchema = Schema.Literals(["arm64", "x64", "other"]);
export const DesktopThemeSchema = Schema.Literals(["light", "dark", "system"]);
export const DesktopUpdateChannelSchema = Schema.Literals(["latest", "nightly"]);
export const DesktopAppStageLabelSchema = Schema.Literals(["Alpha", "Dev", "Nightly"]);
export const DesktopAppBrandingSchema = Schema.Struct({
    baseName: Schema.String,
    stageLabel: DesktopAppStageLabelSchema,
    displayName: Schema.String,
});
export const DesktopRuntimeInfoSchema = Schema.Struct({
    hostArch: DesktopRuntimeArchSchema,
    appArch: DesktopRuntimeArchSchema,
    runningUnderArm64Translation: Schema.Boolean,
});
export const DesktopUpdateStateSchema = Schema.Struct({
    enabled: Schema.Boolean,
    status: DesktopUpdateStatusSchema,
    channel: DesktopUpdateChannelSchema,
    currentVersion: Schema.String,
    hostArch: DesktopRuntimeArchSchema,
    appArch: DesktopRuntimeArchSchema,
    runningUnderArm64Translation: Schema.Boolean,
    availableVersion: Schema.NullOr(Schema.String),
    downloadedVersion: Schema.NullOr(Schema.String),
    downloadPercent: Schema.NullOr(Schema.Number),
    checkedAt: Schema.NullOr(Schema.String),
    message: Schema.NullOr(Schema.String),
    errorContext: Schema.NullOr(Schema.Literals(["check", "download", "install"])),
    canRetry: Schema.Boolean,
});
export const DesktopUpdateActionResultSchema = Schema.Struct({
    accepted: Schema.Boolean,
    completed: Schema.Boolean,
    state: DesktopUpdateStateSchema,
});
export const DesktopUpdateCheckResultSchema = Schema.Struct({
    checked: Schema.Boolean,
    state: DesktopUpdateStateSchema,
});
export const DesktopEnvironmentBootstrapSchema = Schema.Struct({
    label: Schema.String,
    httpBaseUrl: Schema.NullOr(Schema.String),
    wsBaseUrl: Schema.NullOr(Schema.String),
});
export const PickFolderOptionsSchema = Schema.Struct({
    initialPath: Schema.optionalKey(Schema.NullOr(Schema.String)),
});
